module.exports = __webpack_public_path__ + "static/media/fly0279.50760e9d.webp";